/**
 * Mixpanel — init on module load when `VITE_MIXPANEL_TOKEN` is set (any mode).
 * Import from `@/utils/analytics` or this module so init runs before `track`.
 */

import mixpanel from 'mixpanel-browser'

const MIXPANEL_TOKEN = (import.meta.env.VITE_MIXPANEL_TOKEN as string | undefined)?.trim()

/** True when a non-empty project token is configured (local, staging, or production). */
export const IS_MIXPANEL_ENABLED = Boolean(MIXPANEL_TOKEN)

if (IS_MIXPANEL_ENABLED && MIXPANEL_TOKEN) {
  mixpanel.init(MIXPANEL_TOKEN, {
    debug: import.meta.env.DEV,
    track_pageview: false,
  })

  if (import.meta.env.DEV) {
    mixpanel.track('Mixpanel Test Event', { test: true })
    console.info('[Mixpanel] Initialized')
  }
}

export { mixpanel }

export type MixpanelIdentifyPayload = {
  id: string | number
  email?: string | null
}

/** Call after login or when session restores with a known user. */
export function identifyMixpanelUser(user: MixpanelIdentifyPayload): void {
  if (!IS_MIXPANEL_ENABLED) return
  mixpanel.identify(String(user.id))
  const props: Record<string, string> = {}
  if (user.email && user.email.trim()) {
    props.$email = user.email.trim()
  }
  if (Object.keys(props).length > 0) {
    mixpanel.people.set(props)
  }
}

/** Call on logout so the next visitor does not inherit this distinct_id. */
export function resetMixpanelUser(): void {
  if (!IS_MIXPANEL_ENABLED) return
  mixpanel.reset()
}
